import React from 'react';
import { motion } from 'framer-motion';
export function TractionSlide() {
  return <div className="h-full flex flex-col" data-id="element-551">
      {/* Client Logos - compact strip next to headline area */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.3
    }} className="shrink-0 mb-3 flex items-center gap-3" data-id="element-552">
        <span className="text-[11px] text-gray-500 uppercase tracking-wider font-semibold whitespace-nowrap" data-id="element-553">
          Trusted by
        </span>
        <img src="https://cdn.magicpatterns.com/uploads/5CsTt4cy1CHjBrqBGjz6Re/Screenshot_2026-02-10_at_22.07.25.png" alt="Client logos: Roche, GSK, Abbott, AstraZeneca, Alexion, Siemens Healthineers, Novartis, Boehringer Ingelheim, Menarini, Solventum, Nestlé Health Science, LEO" className="h-[80px] w-auto object-contain" data-id="element-554" />
      </motion.div>

      {/* Pipeline image - fills remaining space */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.6
    }} className="flex-1 min-h-0 rounded-2xl border border-gray-200 overflow-hidden shadow-sm bg-white" data-id="element-555">
        <img src="https://cdn.magicpatterns.com/uploads/b2TFkLAGzXyQh8aSGYEjge/image.png" alt="Snakker pipeline and traction: €685K proposals sent across Pipeline, Stage I (€7-12K, 16 accounts), Stage II (€35-75K, 4 accounts), Stage III (€100-300K, GSK Global), and Stage IV (€1M-3M+ growth target)" className="w-full h-full object-contain" data-id="element-556" />
      </motion.div>
    </div>;
}